import { Component } from 'react';

import { Box } from '@mui/material';

import Projects from '../projects/Projects';

export default class MyProjects extends Component {
  componentDidMount() {
    document.title = 'LeKinaSá | My Projects';
  }

  render() {
    return (
      <Box>
        <Box className='center-text big-text page-title'>
          Check out some of my projects...
        </Box>
        <Projects />
      </Box>
    );
  }
}
